import { render } from "./InfoCenterView.vue?vue&type=template&id=2882c5b4&scoped=true"
import script from "./InfoCenterView.vue?vue&type=script&lang=js"
export * from "./InfoCenterView.vue?vue&type=script&lang=js"

import "./InfoCenterView.vue?vue&type=style&index=0&id=2882c5b4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2882c5b4"]])

export default __exports__